import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/arrow-down_16.svg.ts
import { svg } from "lit";
var arrowDown16Svg = svg`
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 4V12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12 8L8 12L4 8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`;
export {
  arrowDown16Svg
};
//# sourceMappingURL=arrow-down_16.svg-IK237GS3.js.map
